import styled, { css } from 'styled-components';
import { truncateWidth } from 'legacyComponents/styled/styleUtils';
import { Icon } from 'components';

export const Main = styled.div`
  position: fixed;
  bottom: 10px;
  left: 50px;
  z-index: 100000;
  width: 420px;
  padding: 20px 20px 10px 20px;
  background-color: ${props => props.theme.color.wfBlack};
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);
  max-height: 420px;
  overflow-y: ${props => !props.minimised && 'auto'};
  /* Media queries */
  @media print {
    display: none;
  }
`;

export const MainTitle = styled.h2`
  font-size: 1.05em;
  color: ${props => props.theme.color.wfWhite};
  margin: ${props => (props.minimised ? '0 0 10px 0' : '0 0 20px 0')};
  font-weight: 600;
  cursor: pointer;
`;

export const ContribSectionTitle = styled.h3`
  font-size: 0.925em;
  color: ${props => props.theme.color.wfWhite};
  font-weight: 600;
`;

const processBarStyles = css`
  background-color: ${props => props.theme.color.wfGrey};
`;

const processValueStyles = css`
  background-color: ${props => props.theme.color.primary};
`;

export const ProcessWrapper = styled.div`
  display: flex;
  width: 380px;
  line-height: 1.4;
  padding: 10px;
  font-size: 0.875em;
  border: 1px solid ${props => props.theme.color.wfGrey700};
  margin: 10px 0;
  progress {
    width: 100%;
    height: 14px;
    appearance: none;
    border: none;
    margin-bottom: -6px;
    &::-webkit-progress-bar {
      ${processBarStyles};
    }
    &::-webkit-progress-value {
      ${processValueStyles};
    }
    &::-moz-progress-bar {
      ${processBarStyles};
    }
    &::-moz-progress-value {
      ${processValueStyles};
    }
  }
`;

export const ProcessName = styled.span`
  color: ${props => props.theme.color.wfWhite};
  min-width: 0;
  max-width: 380px;
  ${truncateWidth('380px')};
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  top: 10px;
  right: 10px;
`;

export const InfoText = styled.span`
  margin-right: 10px;
  vertical-align: super;
  color: ${props => props.theme.color.wfWhite};
`;

export const IconStyled = styled(Icon)`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  cursor: pointer;
  color: ${props => props.theme.color.wfWhite};
`;
